import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/core/services/modules/common.service';
import { environment } from 'src/environments/environment';

export interface DialogData {
  Id: string;
}

@Component({
  selector: 'app-dialog-social-sec-range',
  templateUrl: './dialog-social-sec-range.component.html',
  styleUrls: ['./dialog-social-sec-range.component.scss']
})
export class DialogSocialSecRangeComponent implements OnInit {
  s3Bucket:string;

  form: FormGroup;
  imgCropperResult: string;
  
  constructor(public dialogRef: MatDialogRef<DialogSocialSecRangeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private commonService: CommonService,
    private fb: FormBuilder) { 
      this.form = this.fb.group({
        Day: new FormControl('',Validators.required),
        Max: new FormControl('',Validators.required),
        Min: new FormControl('',Validators.required),
        Year: new FormControl('',Validators.required),
      });
      if(this.data.Id !== undefined) {
        this.commonService.getSocialSecRangeId(this.data.Id).subscribe((rest: any) => {
          this.form.get('Day').setValue(rest.Day);
          this.form.get('Max').setValue(rest.Max);
          this.form.get('Min').setValue(rest.Min);
          this.form.get('Year').setValue(rest.Year);
        });
      }
    }

  ngOnInit(): void {
    this.s3Bucket=environment.api.s3Bucket;
  }


  close() {
    this.dialogRef.close(false);
  }

  save() {
    if(this.form.status === 'VALID')  {
      if(this.data.Id !== undefined) {
        let model = {
          ...this.form.value,
          Id: this.data.Id
        }
        this.commonService.putSocialSecRangeId(this.data.Id, model).subscribe(rest => {
          this.dialogRef.close(true);
        })
      } else {
        this.commonService.postSocialSecRange(this.form.value).subscribe((rest: any) => {
          this.dialogRef.close(true);
        });
      }
    } else {
      this.form.markAllAsTouched();
    }
  }
  
}